import { action, observable } from 'mobx';
// modules
import Localization from 'modules/Localization';
// typings
import { ModalType, GetPriceAlertObject, AlertStatusFilter, PriceAlertNotification } from './typings';

export default class PriceAlertsStore {
  // observables
  @observable exchangeToken = '';

  @observable scripData: DataSchema | null = null;

  @observable modalType: ModalType = 'List';

  @observable currentAlertId = '';

  @observable priceAboveValue = '';

  @observable priceBelowValue = '';

  @observable priceAboveNotes = '';

  @observable priceBelowNotes = '';

  @observable priceAboveError = '';

  @observable priceBelowError = '';

  @observable priceAlertList: GetPriceAlertObject[] = [];

  @observable toDeleteAlertId: string | null = null;

  @observable triggeredAlerts: PriceAlertNotification[] = [];

  @observable selectedStatus: AlertStatusFilter = AlertStatusFilter.ALL;

  // actions
  @action setCurrentScrip = (value: string) => {
    this.exchangeToken = value;
  };

  @action setScripData = (value: DataSchema | null) => {
    this.scripData = value;
  };

  @action setModalType = (value: ModalType) => {
    this.modalType = value;
  };

  @action setCurrentAlertId = (value: string) => {
    this.currentAlertId = value;
  };

  @action setPriceAbove = (value: string) => {
    if (value && Number(value) <= 0) {
      this.setPriceAboveError(Localization.translate('LESS_THAN_ZERO_ERROR'));
    } else {
      this.setPriceAboveError('');
    }
    this.priceAboveValue = value;
  };

  @action setPriceBelow = (value: string) => {
    if (value && Number(value) <= 0) {
      this.setPriceBelowError(Localization.translate('LESS_THAN_ZERO_ERROR'));
    } else {
      this.setPriceBelowError('');
    }
    this.priceBelowValue = value;
  };

  @action setPriceAboveNotes = (value: string) => {
    this.priceAboveNotes = value;
  };

  @action setPriceBelowNotes = (value: string) => {
    this.priceBelowNotes = value;
  };

  @action setPriceAboveError = (value: string) => {
    this.priceAboveError = value;
  };

  @action setPriceBelowError = (value: string) => {
    this.priceBelowError = value;
  };

  @action clearAlertForm = () => {
    this.currentAlertId = '';
    this.priceAboveValue = '';
    this.priceBelowValue = '';
    this.priceAboveNotes = '';
    this.priceBelowNotes = '';
    this.priceAboveError = '';
    this.priceBelowError = '';
    this.currentAlertId = '';
    this.toDeleteAlertId = '';
  };

  @action clear = () => {
    this.exchangeToken = '';
    this.scripData = null;
    this.modalType = 'List';
  };

  @action setPriceAlertsList = (value: GetPriceAlertObject[]) => {
    this.priceAlertList = value;
  };

  @action setToDeleteAlertId = (value: string | null) => {
    this.toDeleteAlertId = value;
  };

  @action showNotification = (notification: PriceAlertNotification) => {
    const alreadyExist = this
      .triggeredAlerts.find(triggered => triggered.id === notification.id);

    if (alreadyExist) return;
    this.triggeredAlerts.push(notification);
    this.triggeredAlerts = this.triggeredAlerts.slice(-4);
  };

  @action hideNotification = (alertId: string) => {
    this.triggeredAlerts = this
      .triggeredAlerts
      .filter(alert => alert.id !== alertId);
  };

  @action setSelectedStatus = (value: AlertStatusFilter) => {
    this.selectedStatus = value;
  };
}
